/**
 * @description
 * Checks if `value` is an `FormData`
 *
 * @example
 * ``` ts
 * isFormData(new FormData());
 * // => true
 * isFormData('form');
 * // => false
 * ```
 *
 * @warning
 * Note `miniprogram` don't support `Blob`, upload please use `wx.uploadFile()`
 *
 * @param value The value to check.
 * @returns Returns `true` if `value` is an FormData object, else `false`.
 *
 * @docsCategory preference/lang
 * @codeFilter is-form-data
 */
export const isFormData = (value): value is FormData => {
  return typeof FormData !== 'undefined' && value instanceof FormData;
};
